import { POST_FORM_CACHE } from "@circle-react/components/constants";
import { toSpaceId } from "@circle-react/components/QuickPost/useQuickPostSpaceId";
import {
  isRecord,
  isTiptapBody,
} from "@circle-react/components/QuickPostV3/data/tiptapBody";
import type { PersistedDraft } from "@circle-react/components/QuickPostV3/data/types";
import {
  clearPersistedFormFieldValues,
  usePersistedFormFieldValues,
} from "@circle-react/hooks/utils/usePersistFormFields";

const normalizePersistedDraft = (
  value: unknown,
): PersistedDraft | undefined => {
  if (!isRecord(value)) return undefined;

  const draft: PersistedDraft = {};
  const spaceId = toSpaceId(value.space_id);

  if (typeof value.body === "string") draft.body = value.body;
  if (typeof value.name === "string") draft.name = value.name;
  if (spaceId) draft.space_id = spaceId;
  if (isTiptapBody(value.tiptap_body)) draft.tiptap_body = value.tiptap_body;
  if (
    "cover_image" in value &&
    (value.cover_image === null ||
      typeof value.cover_image === "object" ||
      typeof value.cover_image === "string")
  ) {
    draft.cover_image = value.cover_image;
  }

  return draft;
};

export const resetPersistedDraft = () => {
  clearPersistedFormFieldValues(POST_FORM_CACHE);
};

export const usePersistedDraft = () => {
  const { getPersistedFormFieldValues } = usePersistedFormFieldValues<unknown>({
    cacheKey: POST_FORM_CACHE,
  });

  return normalizePersistedDraft(getPersistedFormFieldValues());
};
